<script setup lang="ts">
import { RouterLink, useRoute, useRouter } from "vue-router";
import feather from "feather-icons";
import Navigation from "../molecules/Navigation.vue";
import MyLogo from "../../assets/logo.svg?component";
import { useAuthStore } from "@/stores/auth";
import ThemeSwitcher from "@/components/molecules/ThemeSwitcher.vue";

const auth = useAuthStore();
const router = useRouter();

function logout() {
  auth.logout();
  router.push("/");
}

const props = defineProps({
  isMaximized: {
    type: Boolean,
    default: false,
  },
});

const handleClose = () => {
  // close this tab
  window.close();
};

const isTabOwner = window.self !== window.top;

const route = useRoute();
</script>
<template>
  <div>

    <div class="drag bg-base-300 w-full font-mono">
      <div class="topbar-inner flex items-center justify-between h-16 w-full">
        <!-- logo -->
        <div class="flex flex-shrink-0 items-center">
          <RouterLink class="btn btn-ghost hover:bg-inherit" to="/">
            <!-- <img src="/img/icon-32.png" class="w-8 h-8" /> -->
            <MyLogo class="logo w-8 h-8" />
          </RouterLink>
        </div>

        <!-- navigation with gradient fade -->
        <div class="relative flex-1 whitespace-nowrap overflow-x-auto">
          <!-- gradient fade effect (visible if more elements are out of sight) -->
          <div
            class="absolute top-0 left-0 h-[97%] w-8 bg-gradient-to-r from-base-300 to-transparent pointer-events-none lg:block z-10"
          ></div>
          <!-- navigation -->
          <div class="overflow-x-auto scrollbar-narrow lg:scrollbar">
            <div class="flex space-x-4">
              <Navigation class="px-4" />
            </div>
          </div>
          <!-- Gradient fade effect (visible if more elements are out of sight) -->
          <div
            class="absolute top-0 right-0 h-[96%] w-8 bg-gradient-to-l from-base-300 to-transparent pointer-events-none lg:block z-10"
          ></div>
        </div>

        <!-- right actions buttons -->
        <div class="flex items-center">
          <RouterLink
            v-if="!auth.isLoggedIn"
            class="btn btn-ghost"
            to="/login"
            title="Anmelden"
            ><i v-html="feather.icons['log-in'].toSvg()"></i
          ></RouterLink>
          <button
            v-else
            class="btn btn-ghost"
            type="button"
            title="Abmelden"
            @click="logout"
          >
            <i v-html="feather.icons['log-out'].toSvg()"></i>
          </button>
          <ThemeSwitcher />

          <!-- close button -->
          <button
            v-if="isTabOwner"
            class="btn btn-ghost hover:bg-inherit"
            @click="handleClose"
            v-html="feather.icons.x.toSvg()"
          ></button>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.topbar-inner {
  max-width: 82rem;
  margin-inline: auto;
  padding-inline: clamp(1rem, 3.5vw, 2.25rem);
}
.scrollbar-narrow::-webkit-scrollbar {
  width: 4px;
  height: 4px;
  display: none;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.logo path {
  box-shadow: 1cm;
  &:nth-of-type(1) {
    fill: oklch(var(--a) / 1) !important;
  }
  &:nth-of-type(2) {
    fill: oklch(var(--s) / 1) !important;
  }
  &:nth-of-type(3) {
    fill: oklch(var(--p) / 1) !important;
  }
}
</style>
